export const EXPORT_FIELDS_EXPENSE_REPORT = [
  {
    index: '0',
    source: 'referral',
    label: 'Реферал',
  },
  {
    index: '1',
    source: 'type',
    label: 'Тип расхода',
  },
  {
    index: '2',
    source: 'article',
    label: 'Статья затрат',
  },
  {
    index: '3',
    source: 'subarticle',
    label: 'Подстатья затрат',
  },
  {
    index: '4',
    source: 'rowType',
    label: 'Тип строки',
  },
  {
    index: '5',
    source: 'date',
    label: 'Дата',
  },
  {
    index: '6',
    source: 'bankOperationId',
    label: 'ID банковской операции',
  },
  {
    index: '7',
    source: 'amount',
    label: 'Сумма расхода в валюте счета мерчанта',
  },
  {
    index: '8',
    source: 'currency',
    label: 'Валюта счета мерчанта',
  },
  {
    index: '9',
    source: 'convertedAmount',
    label: 'Сумма расхода в выбранной валюте',
  },
  {
    index: '10',
    source: 'convertedCurrency',
    label: 'Выбранная валюта',
  },
  {
    index: '11',
    source: 'comment',
    label: 'Комментарий',
  },
  {
    index: '12',
    source: 'user',
    label: 'Согласующий / Аннулирующий',
  },
];
